import React from 'react';
import { Text } from '@simplybenefits/sb-ui-library';
import { helpers } from '@simplybenefits/sb-utils';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { 
    Add as AddIcon, 
    Remove as RemoveIcon 
} from '@mui/icons-material';

/**
 * 
 * @param {*} ltd 
 * @returns 
 */
const createGradedLTDCoverage = (ltd) => {
    let ltdStr = `Graded scale as follows: You have coverage for ${ ltd.percentageFirstMax }% of the first $${ helpers.numberWithCommas(ltd.firstMax) } of monthly earnings`;

    if (ltd.percentageSecondMax && ltd.secondMax === 0) {
        ltdStr += `, ${ ltd.percentageSecondMax }% of the remainder`;
        return ltdStr;
    }

    if (ltd.percentageSecondMax && ltd.secondMax > 0) {
        ltdStr += `, ${ ltd.percentageSecondMax }% of the next $${ helpers.numberWithCommas(ltd.secondMax) }`;
    }

    if (ltd.percentageThirdMax) {
        ltdStr += `, and ${ ltd.percentageThirdMax }% of ${ ltd.thirdMax > 0 ? 'of the next $' : 'the remainder' }${ ltd.thirdMax ? helpers.numberWithCommas(ltd.thirdMax) : '' }`;
        return ltdStr;
    }

    return ltdStr;
};

/**
 *
 * @param {*} props
 */
export default function Ltd ({ classes, expanded, ltd, handleChange, isStudent }) {
    return (
        <div style={ classes.block }>
            <Accordion
                square
                onChange={handleChange('ltd')}
                style={{ boxShadow: 'none' }}
                disableGutters={true}
            >
                <AccordionSummary
                    classes={{
                        content: classes.panelContent,
                        expanded: classes.expanded,
                        root: classes.root
                    }}
                    expandIcon={expanded.includes('ltd') ? <RemoveIcon /> : <AddIcon />}
                    sx={classes.accordionSummary}
                >
                    <Text medium bold>Long Term Disability</Text>
                </AccordionSummary>
                <AccordionDetails style={classes.panelDetails}>
                    {
                        ltd.isEligible !== 1 ?
                            <div style={classes.row}>
                                <Text small bold margin="20px 0px 10px 0px">
                                    You are currently ineligible for this benefit, if this is a mistake please contact your administrator.
                                </Text>
                            </div>
                            : null
                    }

                    {
                        ltd.isGraded ?
                            <>
                                <Text small bold margin="20px 0px 0px 0px">{createGradedLTDCoverage(ltd)}</Text>
                                <Text small bold margin="0px 0px 20px 0px">{ ltd.isTaxable ? 'Taxable' : 'Non-Taxable' }</Text>
                            </>
                            :
                            <>
                                <Text small bold margin="5px 0px 0px 0px">{ `Flat Amount: You have coverage for ${ ltd.percentageOfFlatAmount }% of monthly Earnings` }</Text>
                                <Text small bold margin="0px 0px 20px 0px">{ ltd.isTaxable ? 'Taxable' : 'Non-Taxable' }</Text>
                            </>
                    }

                    <div>
                        <Text small margin="10px 0px 0px 0px">
                            { ltd.maxEvidence > 0 ? `$${ helpers.formatNumber(ltd.maxEvidence) } Maximum with evidence of insurability.` : null }
                        </Text>

                        <Text small margin="10px 0px 0px 0px">
                            { ltd.maxNoEvidence > 0 ? `$${ helpers.formatNumber(ltd.maxNoEvidence) } Maximum with non-evidence of insurability.` : null }
                        </Text>

                        <Text small margin="5px 0px 0px 0px">
                            { `${ parseInt(ltd.elimPeriod, 10) } Day Elimination Period` }
                        </Text>

                        <Text small margin="5px 0px 0px 0px">
                            {ltd.benefitsPeriod ? `Benefits Period: ${ ltd.benefitsPeriod }` : null }
                        </Text>

                        <Text small margin="5px 0px 0px 0px">
                            {ltd.defOfDisability ? `Definition of Disability: ${ ltd.defOfDisability }` : null}
                        </Text>

                        <Text small margin="5px 0px 0px 0px">
                            { ltd.includeCostOfLivingAdjustments && ltd.costOfLivingAdjustmentsPercentage ? `${ ltd.costOfLivingAdjustmentsPercentage }% Cost of living adjustments to disability benefits.` : null }
                        </Text>

                        <Text small margin="5px 0px 0px 0px">
                            { ltd.includeAllowPreExistingConditions ? "Allow pre-existing Conditions: Yes" : null }
                        </Text>

                        <Text small margin="5px 0px 0px 0px">
                            { ltd.includeLumpSumPaymentDisabledParticipantsDeath ? "Lump sum payment in the event of the 3 months disabled participant’s death: Yes" : null }
                        </Text>

                        {
                            isStudent ?
                                <Text small margin="5px 0px 0px 0px">
                                    { `Terminates at age ${ ltd.terminationAge } or date of participants study if earlier.` }
                                </Text>
                                :
                                <Text small margin="5px 0px 0px 0px">
                                    { `Terminates at age ${ ltd.terminationAge } or date of participants retirement if earlier.` }
                                </Text>
                        }
                    </div>

                </AccordionDetails>
            </Accordion>
        </div>
    );
}